/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectInvoiceResource } from './';
import {
    ProjectInvoiceResourceFromJSON,
    ProjectInvoiceResourceFromJSONTyped,
    ProjectInvoiceResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInvoiceListResource
 */
export interface ProjectInvoiceListResource {
    /**
     * 
     * @type {Array<ProjectInvoiceResource>}
     * @memberof ProjectInvoiceListResource
     */
    invoices: Array<ProjectInvoiceResource>;
}

/**
 * Check if a given object implements the ProjectInvoiceListResource interface.
 */
export function instanceOfProjectInvoiceListResource(value: object): value is ProjectInvoiceListResource {
    if (!('invoices' in value) || value['invoices'] === undefined) return false;
    return true;
}

export function ProjectInvoiceListResourceFromJSON(json: any): ProjectInvoiceListResource {
    return ProjectInvoiceListResourceFromJSONTyped(json, false);
}

export function ProjectInvoiceListResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInvoiceListResource {
    if (json == null) {
        return json;
    }
    return {
        
        'invoices': ((json['invoices'] as Array<any>).map(ProjectInvoiceResourceFromJSON)),
    };
}

export function ProjectInvoiceListResourceToJSON(value?: ProjectInvoiceListResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoices': ((value['invoices'] as Array<any>).map((v) => ProjectInvoiceResourceToJSON(v))),
    };
}

